import { render, staticRenderFns } from "./Assessors.vue?vue&type=template&id=68f4d886"
import script from "./Assessors.vue?vue&type=script&lang=js"
export * from "./Assessors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports